// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ScrollFade_componentStyle__XSiyz","visible":"ScrollFade_visible__k1EJx","fade-in":"ScrollFade_fade-in__4BXlm"};